"use strict";

const $ = require("./main.js");

require('jquery-pjax');


$(document).ready(function ($) {
    $(document).on('change', '.js-centre-selected', function () {
        location.reload();
    });

    $(document).on('click', '.js-filter-local-news-label', function () {
        $('.js-loading-spinner-for-data').fadeIn();
        $('.js-section--news-listings ul').addClass('content-loading');

        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {
            $.pjax.reload('.js-event-results-container', {
                url: '/news-and-events?local=1',
                fragment: '.js-event-results-container',
            });
        } else {
            $.pjax.reload('.js-event-results-container', {
                url: '/news-and-events',
                fragment: '.js-event-results-container',
            });
        }
    });

    if ($.support.pjax) {
        $.pjax.defaults.timeout = 60000;
        $.pjax.defaults.scrollTo = false;

        // $(document).on('click', '.js-pagination-anchor', function () {
        //
        //     $('.js-loading-spinner-for-data').fadeIn();
        //     $('.js-section--news-listings ul').addClass('content-loading');
        //
        //     var url = $(this).attr('href');
        //     $.pjax.reload('.js-event-results-container', {
        //         url: url,
        //         fragment: '.js-event-results-container',
        //     });
        //
        //     $('.js-pagination-anchor').parent().removeClass('active');
        //     $('[data-href=' + $(this).data('href') + ']').parent().addClass('active');
        //     $('html,body').animate({
        //         scrollTop: $('.js-event-results-container').offset().top - 100
        //     }, 400);
        //
        //     return false;
        // });

        // $(document).on('click', '.js-event-switch', function () {
        //     $('.js-loading-spinner').fadeIn();
        //     $('.js-section--news-listings').hide();
        //     $('.js-event-subheading').hide();
        //
        //     var url = $(this).attr('href');
        //     $.pjax.reload('.js-event-results-container', {
        //         url: url,
        //         fragment: '.js-event-results-container',
        //     });
        //
        //     if (url == '/news-and-events') {
        //         $('body').prop('class', 'template--news-list');
        //         $('.js-news-events-switch-switch').prop('href', '/news-and-events/events');
        //     } else {
        //         $('body').prop('class', 'template--event-list');
        //         $('.js-news-events-switch-switch').prop('href', '/news-and-events');
        //     }
        //     return false;
        // });

        $('.js-event-results-container').on('pjax:complete', function () {
            window._ll();
        });

        pjaxForm();
    }

    $(document).on('change', '.js-filter-events', function () {
    })

    $(document).on('change', '.js-filter-centre', function () {
        $('.js-filter-year').val('');
        $('.js-filter-month').val('');
        $(this).closest('form').submit()
    })

    $(document).on('change', '.js-filter-year', function () {
        $('.js-filter-month').val('');
        $(this).closest('form').submit()
    })

    $(document).on('change', '.js-filter-month', function () {
        $(this).closest('form').submit()
    })

});

function pjaxForm() {
    $(document).on('submit', '.js-event-form', function (event) {
        $('.js-loading-spinner-for-data').fadeIn();

        if ($('.js-section--news-listings ul').length) {
            $('.js-section--news-listings ul').addClass('content-loading');
        } else {
            $('.js-section--news-listings').addClass('content-loading');
        }

        $.pjax.submit(event, '.js-event-results-container', {
            fragment: '.js-event-results-container',
        });
    });

    $('.js-section--news-listings').on('pjax:complete', function () {
        $('.js-loading-spinner-for-data').hide();
        $('.js-section--news-listings').fadeIn();
        window._ll();
    });
};

